module.exports = __webpack_public_path__ + "static/media/about-us.310bb818.jpg";